import styled from '@emotion/styled';

import Logo from 'components/Logo';
import useChannelMateriel from 'hooks/useChannelMateriel';
import { useMemo } from 'react';
import { isInElectron } from 'utils/is';
import { User } from './User';
import Nav from './Nav';
import More from './More';
import Guide from './Guide';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';
import { isQuickChat, isTfsoftware } from 'productLine';
import quickChatSideLogo from 'assets/channels/quickchat/siderLogo.svg';
import tfsoftwareLogo from 'assets/channels/tfsoftware/logo.png';
import greatChatLogo from 'assets/channels/greatchat/logo.png';
import { isGreatChatDemoChannel } from 'services/chattt';

const Wrapper = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 64px;
  height: 100%;
  padding: 0 0 32px;
  background: var(--fett-app-sider-nav-primary-bg);
  box-shadow: 2px 0 8px 0 rgb(29 35 41 / 5%);
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  > * {
    flex: 0 0 auto;
  }
`;

const StyledNav = styled(Nav)`
  flex: 1 0 0 !important;
  padding: 14px 0;
`;

const StyledLogo = styled(Logo)`
  width: 80%;
  padding: 16px 0;
  margin-bottom: 12px;
  background-color: transparent;
`;

/**
 * 应用侧边栏属性
 */
export interface AppSiderProps extends React.HTMLAttributes<HTMLElement> {}

/**
 * 应用侧边栏
 * @param props 应用侧边栏属性
 */
function AppSider(props: AppSiderProps) {
  const { ...otherProps } = props;
  const { opened, config } = useChannelMateriel();

  const { whiteListConfig: { AE_CONVERSATION = false } = {} } = useOrgConfigStateValue();

  const logo = useMemo(() => {
    const width = 32;

    if (isQuickChat) {
      return <StyledLogo width={width} src={quickChatSideLogo} />;
    }

    if (isTfsoftware) {
      return <StyledLogo width={width} src={tfsoftwareLogo} />;
    }

    if (opened && config && config.siderLogo) {
      return <StyledLogo width={width} src={config.siderLogo} />;
    }

    if (isGreatChatDemoChannel) {
      return <StyledLogo width={width} src={greatChatLogo} />;
    }

    return <StyledLogo width={width} style={{ color: '#A1C6FF' }} />;
  }, [config, opened]);

  return (
    <Wrapper {...otherProps}>
      {AE_CONVERSATION ? <div style={{ height: '20px' }} /> : logo}
      <User />
      <StyledNav />
      <More />
      {isInElectron && <Guide />}
    </Wrapper>
  );
}

export default AppSider;
